/**
 * @author leiling.cp
 * @version 2015.3.20
 * @description 工具类
 */


var Util = function() {

};

Util.prototype = {
    getCookie: function(sKey) {
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setCookie: function(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        var sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        sDomain = sDomain ? sDomain : 'alibaba.com';
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    },
    clearCookie: function(sKey, sPath, sDomain) {
        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    },
    getBeaconId: function() {
        return this.getCookie("cna");
    },
    getQueryString: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return window.unescape(r[2]);
        }
        return null;
    },
    debug: function(fmt) {
        fmt = "[" + this.getFormatTime() + "] " + this.coerce(fmt);

        if (window.console && window.console.log) {
            window.console.log(fmt);
        }
    },
    coerce: function(val) {
        if (val instanceof Error) {
            return val.stack || val.message;
        }
        return val;
    },
    getFormatTime: function() {
        var now = new Date(),
            year = now.getFullYear(),
            month = Number(now.getMonth()) + 1,
            day = now.getDate(),
            hour = now.getHours(),
            min = now.getMinutes(),
            sec = now.getSeconds();

        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        hour = hour < 10 ? "0" + hour : hour;
        min = min < 10 ? "0" + min : min;
        sec = sec < 10 ? "0" + sec : sec;

        return year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
    }
};

module.exports = new Util();
